var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class SignedPlayerInfo {
  constructor() {
    // Required for all platforms
    __publicField(this, "platform");
    /** An optional developer specified payload provided during the request */
    __publicField(this, "payload");
    /** The players unique identifier on the platform */
    __publicField(this, "playerId");
    /** The player's authentication token signature */
    __publicField(this, "signature");
    this.platform = "";
    this.payload = "";
    this.playerId = "";
    this.signature = "";
  }
  fromFacebookData(data, requestPayload) {
    this.platform = "fb";
    this.payload = requestPayload || "";
    this.playerId = data.getPlayerID();
    this.signature = data.getSignature();
    return this;
  }
  fromLineData(data) {
    this.platform = "line";
    this.payload = data.payload;
    this.playerId = data.playerId;
    this.signature = data.idToken;
    return this;
  }
  fromLinkData(data, requestPayload) {
    this.platform = "link";
    this.payload = requestPayload || "";
    this.playerId = data.getPlayerID();
    this.signature = data.getSignature();
    return this;
  }
  fromZoomData(data) {
    this.platform = "zoom";
    this.payload = data.payload;
    this.playerId = data.playerId;
    this.signature = data.idToken;
    return this;
  }
}
export {
  SignedPlayerInfo
};
